import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';
import { createStore } from 'redux';

import { Provider } from 'react-redux';
import rootReducer from "./reducers/rootReducer";



const store = createStore(
    rootReducer
);






ReactDOM.render(<Provider store={store}>
    <div>
        <App />
    </div>
</Provider>, document.getElementById('root'));
